import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { TypographyVariant } from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { Button } from "../../core/Button/Button";
import { StaticImage } from "../../core/StaticImage/StaticImage";
import { useStyles } from "./ConsoleServiceCard.style";
import { FeaturedCard } from "@onmo/graphql/graphql";
import { getFeaturedCardData } from "../../../models/console";
import { useNavigate } from "react-router-dom";
import { AnalyticsGA4 } from "../../../models/analyticsGA4";

interface IConsoleServiceCardProps {
  type: "install" | "download";
  onClick?: () => void;
  data: FeaturedCard;
}

export const ConsoleServiceCard: FC<
  HTMLAttributes<HTMLDivElement> & IConsoleServiceCardProps
> = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { type, onClick, className, data, ...othersProps } = props;
  const { title, assets, description, internalPath } =
    getFeaturedCardData(data);

  const handle = () => {
    AnalyticsGA4.homepageAction(type === "install" ? "byog" : "apps");
    if (onClick) {
      onClick();
    } else {
      navigate(internalPath);
    }
  };

  return (
    <div
      {...othersProps}
      className={clsx(classes.root, className)}
      data-gamepad="byog-card"
      data-selected-class={classes.selected}
      onClick={handle}
    >
      <StaticImage
        src={assets?.image1X}
        src2x={assets?.image2X}
        src3x={assets?.image3X}
        className={classes.bgImage}
      />
      <div className={classes.content}>
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {title}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB3Regular}
          className={classes.desc}
        >
          {description}
        </Typography>
        <Button
          variant="outlined"
          className={classes.btnAction}
          disableGamepadAction
        >
          Explore
        </Button>
      </div>
    </div>
  );
};
